import { Injectable } from '@angular/core';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class RoutestateService {
  menuActive = '';
  constructor(private router: Router, private activatedRoute: ActivatedRoute) {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        // Traverse the active route tree
        var snapshot = this.activatedRoute.snapshot;
        var activated = this.activatedRoute.firstChild;
        if (activated != null) {
          while (activated != null) {
            snapshot = activated.snapshot;
            activated = activated.firstChild;
          }
        }
        this.menuActive = snapshot.data['menu'] || ''; // menu data is get from app-routing.module.ts
      }
    });
  }
}
